import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageHero from '../../components/ui-shree/PageHero';
import Dashboard from '../../components/Dashboard';

/**
 * Page wrapper for the Creator Dashboard. Auth is intentionally simple for
 * this demo: handle comes from ?handle=maya-k OR a small input on the page.
 * Replace with real session/wallet auth in production.
 */
const DashboardPage = () => {
  const [params, setParams] = useSearchParams();
  const initialHandle = params.get('handle') || '';
  const [handle, setHandle] = useState(initialHandle);
  const [draft, setDraft] = useState(initialHandle);

  useEffect(() => {
    setHandle(initialHandle);
    setDraft(initialHandle);
  }, [initialHandle]);

  const onSubmit = (e) => {
    e.preventDefault();
    const cleaned = draft.trim().replace(/^@/, '');
    if (!cleaned) return;
    setHandle(cleaned);
    setParams({ handle: cleaned });
  };

  return (
    <div data-testid="dashboard-page">
      <PageHero
        overline="Creator · Private View"
        title={
          <>
            Your tokens, your <em className="text-[#90B0BF]">numbers</em>.
          </>
        }
        subtitle="A private read-out of your $SEVA balance, content performance, attributed orders, and where you stand among the global Sevagram creators."
        testId="dashboard-hero"
      >
        <form
          onSubmit={onSubmit}
          data-testid="dashboard-handle-form"
          className="flex items-end gap-3 max-w-md border-b border-[#90B0BF]/40 pb-3"
        >
          <div className="flex-1">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-2">
              Creator handle
            </p>
            <input
              type="text"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder="maya-k"
              data-testid="dashboard-handle-input"
              className="w-full bg-transparent text-[#7C9CB1] placeholder-[#90B0BF]/60 font-light text-base focus:outline-none"
            />
          </div>
          <button
            type="submit"
            data-testid="dashboard-handle-submit"
            className="bg-[#7C9CB1] text-[#F4F8F9] px-6 py-3 text-[11px] tracking-[0.22em] uppercase hover:bg-[#90B0BF] transition-colors"
          >
            Open
          </button>
        </form>
      </PageHero>

      <section className="px-6 md:px-12 pb-32">
        <div className="max-w-[1400px] mx-auto">
          {handle ? (
            <Dashboard handle={handle} />
          ) : (
            <div
              data-testid="dashboard-empty"
              className="border border-[#C1D7E2] bg-[#F4F8F9] p-16 text-center"
            >
              <p className="font-serif italic text-2xl text-[#7C9CB1] mb-3">
                Enter your creator handle above to begin.
              </p>
              <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#90B0BF]">
                Try one of ours · maya-k · noor-a · ishan-r
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default DashboardPage;
